export default "__VITE_ASSET__DTNoEFbT__"